import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../assets/images/chat/filter-bar.svg'
import _imports_1 from '../../../assets/images/chat/all-calls.svg'
import _imports_2 from '../../../assets/images/chat/outgoing-call.svg'
import _imports_3 from '../../../assets/images/chat/incoming-call.svg'
import _imports_4 from '../../../assets/images/chat/missed-call.svg'
import _imports_5 from '../../../assets/images/chat/video-call-icon.svg'
import _imports_6 from '../../../assets/images/chat/voice-call.svg'
import _imports_7 from '../../../assets/images/chat/messenger-icon.svg'


const _hoisted_1 = { class: "call-history-wrapper" }
const _hoisted_2 = { class: "call-history-header" }
const _hoisted_3 = { class: "d-flex align-items-center h-100" }
const _hoisted_4 = {
  key: 0,
  class: "fw-semibold mb-0 text-app-secondary"
}
const _hoisted_5 = {
  key: 1,
  class: "fw-semibold mb-0 text-app-secondary"
}
const _hoisted_6 = { class: "ms-auto" }
const _hoisted_7 = { class: "dropdown" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "cursor-pointer",
  src: _imports_0,
  "data-bs-toggle": "dropdown"
}, null, -1 /* HOISTED */)
const _hoisted_9 = {
  class: "dropdown-menu py-1 px-2 sort-dropdown-menu",
  "aria-labelledby": "Chat-Options"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createTextVNode(" All "),
  /*#__PURE__*/_createElementVNode("img", {
    class: "sort-type-icon",
    src: _imports_1
  })
], -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createTextVNode(" Outgoing "),
  /*#__PURE__*/_createElementVNode("img", {
    class: "sort-type-icon",
    src: _imports_2
  })
], -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createTextVNode(" Incoming "),
  /*#__PURE__*/_createElementVNode("img", {
    class: "sort-type-icon",
    src: _imports_3
  })
], -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createTextVNode(" Missed "),
  /*#__PURE__*/_createElementVNode("img", {
    class: "sort-type-icon",
    src: _imports_4
  })
], -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "search-input p-3 bg-white d-md-none border-bottom" }
const _hoisted_19 = { class: "d-flex justify-content-between align-items-center min-width-0 h-100" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "ps-2 flex-grow-1 min-width-0" }
const _hoisted_22 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_23 = { class: "mb-1 fw-bold text-dark" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_27 = { class: "text-truncate me-2" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1 /* HOISTED */)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1 /* HOISTED */)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { key: 2 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1 /* HOISTED */)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "d-flex align-items-center" }
const _hoisted_38 = {
  key: 0,
  class: "ms-2 ms-lg-0 me-2 call-duration-width"
}
const _hoisted_39 = { class: "mx-2 mx-lg-5 call-time-width d-none d-md-inline" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1 /* HOISTED */)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1 /* HOISTED */)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 0,
  class: "py-1"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "loader-parent" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "msg-loader" })
], -1 /* HOISTED */)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 1,
  class: "nav-item list-group-item text-dark h-100 d-flex justify-content-center text-middle flex flex-column"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center" }, "No Call History Found.", -1 /* HOISTED */)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ava-initials me-1" }, [
    /*#__PURE__*/_createElementVNode("span")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ms-2 flex-grow-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-90 lighten" }),
    /*#__PURE__*/_createElementVNode("div", { class: "message-content" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-70 lighten" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_56 = [
  _hoisted_55
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CallSearch = _resolveComponent("CallSearch")!
  const _component_AvaInitials = _resolveComponent("AvaInitials")!
  const _component_ScrollPagination = _resolveComponent("ScrollPagination")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.callFilterType == 'All' || _ctx.callFilterType == null)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_4, " Call History "))
          : (_openBlock(), _createElementBlock("h6", _hoisted_5, [
              _createElementVNode("i", {
                class: "fas fa-chevron-left me-3 cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterCallLog('All')))
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.callFilterType ? _ctx.CallType.getDescriptionUsingValue(_ctx.callFilterType) : ""), 1 /* TEXT */)
            ])),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                class: "dropdown-item sort-dropdown",
                href: "javascript:void(0);",
                id: "all-filter",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterCallLog('All')))
              }, _hoisted_11),
              _createElementVNode("a", {
                class: "dropdown-item sort-dropdown",
                href: "javascript:void(0);",
                id: "outgoing-filter",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterCallLog(_ctx.CallType.enum.Outgoing)))
              }, _hoisted_13),
              _createElementVNode("a", {
                class: "dropdown-item sort-dropdown",
                href: "javascript:void(0);",
                id: "incoming-filter",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterCallLog(_ctx.CallType.enum.Incoming)))
              }, _hoisted_15),
              _createElementVNode("a", {
                class: "dropdown-item sort-dropdown",
                href: "javascript:void(0);",
                id: "missed-filter",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterCallLog(_ctx.CallType.enum.Missed)))
              }, _hoisted_17)
            ])
          ])), [
            [_directive_tooltip, { title: `Filter by Call Type`, placement: 'left', trigger: `hover` }]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_CallSearch)
    ]),
    _createVNode(_component_ScrollPagination, {
      class: "content-y h-100",
      "page-number": _ctx.pageNumber,
      "all-pages-loaded": _ctx.allPagesLoaded,
      "is-loading": _ctx.loadMore,
      "has-error": _ctx.hasError,
      onPageNumberUpdate: _ctx.pageNumberUpdated
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", {
          class: _normalizeClass(["nav scroll-paginate list-group list-group-flush message-navigation", { 'custom-scrollbar': _ctx.userOs == 'Windows' }])
        }, [
          (!_ctx.isLoading && _ctx.callHistoryList && _ctx.callHistoryList.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.callHistoryList, (callDetail) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: callDetail.id,
                    class: "nav-item list-group-item message-list-item call-list call-list-height"
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_AvaInitials, {
                          classes: "me-1",
                          initialsType: callDetail?.conversationType,
                          user: _ctx.getInitials(callDetail.callParticipants),
                          showStatus: true
                        }, null, 8 /* PROPS */, ["initialsType", "user"]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, [
                              (callDetail.title)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(callDetail.title), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.formatDisplayUsers(
                                                        _ctx.getCallParticipants(callDetail?.callParticipants)
                                                    )), 1 /* TEXT */))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              (callDetail.callHistoryType == _ctx.CallType.enum.Incoming)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _hoisted_30))
                                : _createCommentVNode("v-if", true),
                              (callDetail.callHistoryType == _ctx.CallType.enum.Outgoing)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _hoisted_33))
                                : _createCommentVNode("v-if", true),
                              (callDetail.callHistoryType == _ctx.CallType.enum.Missed)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _hoisted_36))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("span", {
                                class: _normalizeClass(["ms-2 d-none d-md-inline", {
                                                    'text-danger': callDetail.callHistoryType == _ctx.CallType.enum.Missed
                                                }])
                              }, _toDisplayString(_ctx.CallType.getDescriptionUsingValue(callDetail.callHistoryType)), 3 /* TEXT, CLASS */)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        (callDetail.callHistoryType != _ctx.CallType.enum.Missed)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(callDetail.callDuration), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.formatDateTimeToLocal(callDetail.callStartTime)), 1 /* TEXT */),
                        _createElementVNode("span", {
                          class: _normalizeClass(["ms-1", [
                                        _ctx.dialogOpened ? 'cursor-not-allowed' : 'cursor-pointer',
                                        callDetail.isDeletedParticipant == true ? 'hidden' : 'cursor-pointer'
                                    ]]),
                          onClick: ($event: any) => (
                                        !_ctx.dialogOpened && _ctx.startMeeting(_ctx.ConversationRoomTypeEnum.VideoCall, callDetail)
                                    )
                        }, _hoisted_42, 10 /* CLASS, PROPS */, _hoisted_40),
                        _createElementVNode("span", {
                          class: _normalizeClass(["mx-2 mx-lg-4", [
                                        _ctx.dialogOpened ? 'cursor-not-allowed' : 'cursor-pointer',
                                        callDetail.isDeletedParticipant == true ? 'hidden' : 'cursor-pointer'
                                    ]]),
                          onClick: ($event: any) => (
                                        !_ctx.dialogOpened && _ctx.startMeeting(_ctx.ConversationRoomTypeEnum.AudioCall, callDetail)
                                    )
                        }, _hoisted_45, 10 /* CLASS, PROPS */, _hoisted_43),
                        _createElementVNode("span", {
                          class: _normalizeClass([[callDetail.isDeletedParticipant == true ? 'hidden' : 'cursor-pointer'], "cursor-pointer"]),
                          onClick: ($event: any) => (_ctx.navigateToConversation(callDetail.conversationId))
                        }, _hoisted_48, 10 /* CLASS, PROPS */, _hoisted_46)
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */)),
                (_ctx.loadMore)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_49, _hoisted_51))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (!_ctx.isLoading && _ctx.callHistoryList?.length == 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_52, _hoisted_54))
            : _createCommentVNode("v-if", true),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList(9, (i) => {
                return _createElementVNode("li", {
                  key: i,
                  class: "nav-item list-group-item call-list-height d-flex justify-content-center text-middle flex flex-column"
                }, _hoisted_56)
              }), 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page-number", "all-pages-loaded", "is-loading", "has-error", "onPageNumberUpdate"])
  ]))
}